
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facility-selection",
      function () {
        return require("private-next-pages/facility-selection/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/facility-selection"])
      });
    }
  